import { z } from 'zod'

export type AttributesMath = {
  caption?: string
  equation?: string
}

export const attributesMathSchema = z.object({
  caption: z.string().default(''),
  equation: z.string().default(''),
}) satisfies z.ZodType<AttributesMath>
